var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'perso ' + _vm.perso + ' d-none d-md-block'},[_c('img',{attrs:{"src":require(("@/assets/perso/XL_PERSO_" + _vm.perso + ".svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }